import { LEGAL_CONFIG } from "../../../config/legal";

export const regulaminSections = [
  {
    id: "s1",
    title: "§1 Postanowienia ogolne",
    content: [
      `Niniejszy Regulamin okresla zasady korzystania z internetowej Platformy Sprzedazowej ${LEGAL_CONFIG.platformName} dzialajacego pod adresem ${LEGAL_CONFIG.platformUrl}, prowadzonego przez ${LEGAL_CONFIG.companyName}, ${LEGAL_CONFIG.companyAddress}, NIP: ${LEGAL_CONFIG.companyNip}, REGON: ${LEGAL_CONFIG.companyRegon} (dalej: "Sprzedawca"), oraz zasady sprzedazy produktow cyfrowych (dalej: "Produkty") i swiadczenia uslug droga elektroniczna.`,
      `Regulamin stanowi prawnie wiazaca umowe sprzedazy miedzy Sprzedawca a osoba dokonujaca zakupu (dalej: "Klient" / "Kupujacy").`,
      `Korzystanie z Platformy, skladanie zamowien oraz realizacja zakupow oznacza akceptacje Regulaminu.`,
    ],
  },
  {
    id: "s2",
    title: "§2 Definicje",
    items: [
      "Produkt Cyfrowy - tresc cyfrowa w rozumieniu przepisow prawa, dostarczana droga elektroniczna poprzez udostepnienie pliku do pobrania lub linku, obejmujaca wykroje krawieckie w formacie cyfrowym.",
      "Umowa Sprzedazy - umowa sprzedazy Produktow Cyfrowych zawierana na odleglosc miedzy Klientem a Sprzedawca z wykorzystaniem strony Platformy.",
      "Konsument - osoba fizyczna zawierajaca umowe niezwiązana bezposrednio z dzialalnoscia gospodarcza.",
      "Usluga Elektroniczna - usluga swiadczona droga elektroniczna w rozumieniu obowiazujacego prawa.",
    ],
  },
  {
    id: "s3",
    title: "§3 Zakres dzialalnosci Platformy Sprzedazowej",
    content: [
      `Platforma ${LEGAL_CONFIG.platformName} prowadzi sprzedaz wykrojow krawieckich online. Produkty przeznaczone sa do uzytku wlasnego. Zakazuje sie dalszej dystrybucji bez zgody Sprzedawcy.`,
    ],
  },
  {
    id: "s4",
    title: "§4 Zamowienia i platnosci",
    content: [
      "Zamowienia mozna skladac 24 godziny na dobe, 7 dni w tygodniu poprzez strone internetowa.",
      "Zamowienie moze byc zlozone bez rejestracji konta lub po uprzedniej rejestracji.",
      "Do zlozenia zamowienia wymagane jest podanie adresu e-mail i danych umozliwiajacych realizacje zamowienia.",
      "Platnosci realizowane sa elektronicznie (BLIK, przelew, karta). Umowa zawierana jest po zaksiegowaniu platnosci.",
    ],
  },
  {
    id: "s5",
    title: "§5 Zawarcie umowy sprzedazy",
    content: [
      "Umowa sprzedazy zostaje zawarta z chwila potwierdzenia przyjecia zamowienia przez Sprzedawce oraz dokonania przez Klienta platnosci.",
      "Klient zobowiazany jest podac prawdziwe dane kontaktowe. Niedopelnienie tego obowiazku moze utrudnic realizacje zamowienia.",
    ],
  },
  {
    id: "s6",
    title: "§6 Cena i platnosci",
    content: [
      "Ceny Produktow sa podawane w zlotych polskich i zawieraja podatek VAT.",
      "Klient moze wybrac forme platnosci dostepna na Platformie (przelew online, karta platnicza, platnosc elektroniczna itp.).",
      "Umowa sprzedazy zostaje zawarta z chwila zaksiegowania platnosci przez Sprzedawce.",
    ],
  },
  {
    id: "s7",
    title: "§7 Dostawa produktow cyfrowych",
    content: [
      "Po oplaceniu zamowienia Sprzedawca udostepnia Produkt Cyfrowy w formie do pobrania - poprzez link na strone podsumowania zamowienia, e-mail lub konto Klienta.",
      "Produkt uznaje sie za dostarczony w momencie, gdy Klient lub jego urzadzenie uzyska dostep do Produktu lub linku do pobrania.",
    ],
  },
  {
    id: "s8",
    title: "§8 Prawa autorskie i licencja",
    content: [
      "Wszystkie wykroje sa chronione prawem autorskim.",
      "Sprzedawca oswiadcza, ze jest uprawniony do rozpowszechniania Produktow lub posiada odpowiednie licencje.",
      "Klient nabywa niewylaczne prawo do korzystania z Produktu Cyfrowego na wlasne potrzeby - powielanie, rozpowszechnianie, udostepnianie osobom trzecim bez zgody Sprzedawcy jest zabronione.",
    ],
  },
  {
    id: "s9",
    title: "§9 Prawo odstapienia od umowy - produkty cyfrowe",
    content: [
      "Zgodnie z przepisami prawa Klient bedacy konsumentem ma prawo odstapic od umowy zawartej na odleglosc w terminie 14 dni kalendarzowych bez podania przyczyny, liczac od dnia zawarcia umowy.",
      "Prawo odstapienia nie przysluguje jednak w pelnym zakresie w przypadkach dostawy Produktow Cyfrowych, jezeli swiadczenie uslugi rozpoczelo sie za zgoda Klienta przed uplywem terminu do odstapienia, oraz Klient zostal poinformowany o utracie prawa do odstapienia po rozpoczeciu pobierania (zgodnie z obowiazujacym prawem konsumenckim).",
      "Klient akceptuje powyzsze poprzez zaznaczenie checkboxa podczas skladania zamowienia.",
    ],
  },
  {
    id: "s10",
    title: "§10 Pole wyboru [checkbox] zgody na utrate prawa do zwrotu",
    content: [
      "Podczas skladania zamowienia Klient zobowiazany jest zaznaczyc pole:",
    ],
    checkbox:
      "[ ] Wyrazam zgode na natychmiastowe rozpoczecie realizacji zamowienia i przyjmuje do wiadomosci, ze po pobraniu produktu trace prawo do odstapienia od umowy.",
    afterCheckbox:
      "Brak zaznaczenia pola wyboru uniemozliwia realizacje zamowienia.",
  },
  {
    id: "s11",
    title: "§11 Reklamacje i niezgodnosc produktu",
    content: [
      "Sprzedawca odpowiada za niezgodnosc Produktu Cyfrowego z umowa, jezeli wada ujawni sie w chwili dostarczenia lub wkrotce po dostarczeniu.",
      `Reklamacje Klientow sa rozpatrywane w terminie 14 dni kalendarzowych od dnia ich zgloszenia. Reklamacje nalezy skladac droga mailowa pod adresem ${LEGAL_CONFIG.complaintsEmail}.`,
      "Klient moze zadac doprowadzenia Produktu do zgodnosci z umowa, obnizenia ceny lub odstapienia od umowy, jezeli wada jest istotna.",
    ],
  },
  {
    id: "s12",
    title: "§12 Ograniczenia i obowiazki Klienta",
    content: [
      "Klient zobowiazuje sie korzystac z Platformy i Produktow zgodnie z prawem, dobrymi obyczajami oraz niniejszym Regulaminem.",
      "Klient nie moze umieszczac tresci naruszajacych prawa osob trzecich, ani wykorzystywac Produktow w sposob naruszajacy prawo autorskie.",
    ],
  },
  {
    id: "s13",
    title: "§13 Ochrona danych osobowych (RODO)",
    content: [
      "Administratorem danych osobowych Klientow jest Sprzedawca - dane sa przetwarzane zgodnie z polityka prywatnosci i RODO.",
      "Klient ma prawo dostepu do swoich danych, ich poprawiania i usuniecia zgodnie z obowiazujacymi przepisami.",
    ],
  },
  {
    id: "s14",
    title: "§14 Postanowienia koncowe",
    content: [
      "Regulamin obowiazuje przez czas nieokreslony.",
      "Sprzedawca zastrzega sobie prawo do zmiany Regulaminu z waznych przyczyn (zmiany prawa, technologii lub sposobow platnosci), z informowaniem o tym Klienta.",
      "W sprawach nieuregulowanych znajduja zastosowanie obowiazujace przepisy prawa polskiego, w szczegolnosci ustawa o prawach konsumenta, ustawa o swiadczeniu uslug droga elektroniczna, Kodeks cywilny oraz inne przepisy powszechnie obowiazujace.",
    ],
  },
];

export const privacyPolicySections = [
  {
    id: "p1",
    title: "§1 Postanowienia ogólne",
    content: [
      `Niniejsza Polityka Prywatności określa zasady przetwarzania i ochrony danych osobowych Użytkowników korzystających z internetowej platformy sprzedażowej ${LEGAL_CONFIG.platformName} sprzedającej wykroje krawieckie w formie cyfrowej (dalej: „Sklep”).`,
      "Administratorem danych osobowych jest właściciel Platformy (dalej: „Administrator”).",
      "Administrator przetwarza dane osobowe zgodnie z obowiązującymi przepisami prawa, w szczególności: RODO, ustawą o ochronie danych osobowych oraz ustawą o świadczeniu usług drogą elektroniczną.",
    ],
  },
  {
    id: "p2",
    title: "§2 Zakres zbieranych danych",
    items: [
      "imię i nazwisko",
      "adres e-mail",
      "numer telefonu",
      "adres zamieszkania lub prowadzenia działalności",
      "dane do faktury",
      "adres IP",
      "dane zawarte w formularzu kontaktowym",
      "dane związane z zamówieniami",
    ],
    content: [
      "Podanie danych jest dobrowolne, jednak niezbędne do realizacji zamówień lub korzystania z usług Platformy.",
    ],
  },
  {
    id: "p3",
    title: "§3 Cele przetwarzania danych",
    items: [
      "realizacja zamówień i umów sprzedaży produktów cyfrowych",
      "obsługa płatności i rozliczeń",
      "prowadzenie konta Klienta",
      "kontakt z Klientem",
      "obsługa reklamacji i odstąpień od umowy",
      "realizacja obowiązków księgowych i podatkowych",
      "prowadzenie działań marketingowych (za zgodą Użytkownika)",
      "poprawa funkcjonowania Platformy",
    ],
  },
  {
    id: "p4",
    title: "§4 Podstawa prawna przetwarzania danych",
    items: [
      "art. 6 ust. 1 lit. b RODO – wykonanie umowy",
      "art. 6 ust. 1 lit. c RODO – obowiązek prawny",
      "art. 6 ust. 1 lit. a RODO – zgoda Użytkownika",
      "art. 6 ust. 1 lit. f RODO – prawnie uzasadniony interes Administratora",
    ],
  },
  {
    id: "p5",
    title: "§5 Odbiorcy danych",
    items: [
      "firmy księgowe",
      "operatorzy płatności",
      "dostawcy usług IT i hostingowych",
      "firmy obsługujące system mailingowy",
      "organy publiczne – na podstawie przepisów prawa",
    ],
    content: [
      "Dane nie są przekazywane poza Unię Europejską, chyba że zapewniony jest odpowiedni poziom ochrony.",
    ],
  },
  {
    id: "p6",
    title: "§6 Okres przechowywania danych",
    items: [
      "przez czas trwania umowy",
      "po jej zakończeniu – przez okres wymagany przepisami prawa",
      "do momentu cofnięcia zgody – w przypadku danych przetwarzanych na jej podstawie",
    ],
  },
  {
    id: "p7",
    title: "§7 Prawa osób, których dane dotyczą",
    items: [
      "prawo dostępu do danych",
      "prawo sprostowania danych",
      "prawo usunięcia danych",
      "prawo ograniczenia przetwarzania",
      "prawo przenoszenia danych",
      "prawo sprzeciwu",
      "prawo cofnięcia zgody w dowolnym momencie",
      "prawo wniesienia skargi do Prezesa UODO (www.uodo.gov.pl)",
    ],
  },
  {
    id: "p8",
    title: "§8 Zabezpieczenie danych",
    items: [
      "certyfikat SSL",
      "zabezpieczenia serwerów",
      "systemy kontroli dostępu",
      "regularne aktualizacje oprogramowania",
    ],
  },
  {
    id: "p9",
    title: "§9 Pliki cookies",
    items: [
      "prawidłowe działanie strony",
      "analiza statystyk",
      "cele marketingowe",
    ],
    content: [
      "Użytkownik może zarządzać plikami cookies za pomocą ustawień przeglądarki.",
    ],
  },
  {
    id: "p10",
    title: "§10 Produkty cyfrowe",
    content: [
      "Platforma oferuje wyłącznie produkty cyfrowe w postaci wykrojów krawieckich.",
      "Po dokonaniu zakupu Klient otrzymuje dostęp do plików do pobrania.",
      "Produkty cyfrowe objęte są ochroną praw autorskich.",
    ],
  },
  {
    id: "p11",
    title: "§11 Marketing i newsletter",
    content: [
      "Użytkownik może zapisać się do newslettera za dobrowolną zgodą.",
      "Zgoda może być cofnięta w dowolnym momencie.",
      "Dane wykorzystywane do celów marketingowych nie są przekazywane osobom trzecim.",
    ],
  },
  {
    id: "p12",
    title: "§12 Zautomatyzowane podejmowanie decyzji i profilowanie",
    content: [
      "Dane osobowe nie są wykorzystywane do zautomatyzowanego podejmowania decyzji ani profilowania.",
    ],
  },
  {
    id: "p13",
    title: "§13 Postanowienia końcowe",
    content: [
      "Administrator zastrzega sobie prawo do zmian niniejszej Polityki Prywatności.",
      "Zmiany wchodzą w życie z dniem publikacji na stronie Platformy.",
      "Aktualna wersja dokumentu jest zawsze dostępna na stronie internetowej.",
    ],
  },
  {
    id: "p14",
    title: "Administrator Danych Osobowych",
    content: [
      `Nazwa firmy: ${LEGAL_CONFIG.companyName}`,
      `Adres: ${LEGAL_CONFIG.companyAddress}`,
      `E-mail: ${LEGAL_CONFIG.complaintsEmail}`,
      "Data ostatniej aktualizacji: [UZUPEŁNIJ]",
    ],
  },
];

export const creatorCooperationSections = [
  {
    id: "c1",
    title: "§1 Postanowienia ogólne",
    content: [
      "Niniejszy regulamin określa zasady współpracy pomiędzy Operatorem Platformy Pattern Market a Twórcami.",
    ],
  },
  {
    id: "c2",
    title: "§2 Warunki uczestnictwa",
    content: [
      "Twórca oświadcza, że posiada pełne prawa autorskie do publikowanych materiałów.",
    ],
  },
  {
    id: "c3",
    title: "§3 Obowiązki Twórcy",
    content: [
      "Twórca zobowiązuje się do dostarczania treści zgodnych z prawem i regulaminem.",
    ],
  },
  {
    id: "c4",
    title: "§4 Rozliczenia",
    content: [
      "Rozliczenia odbywają się na podstawie indywidualnej umowy.",
    ],
  },
  {
    id: "c5",
    title: "§5 Ochrona danych (RODO)",
    content: [
      "Dane osobowe przetwarzane są zgodnie z RODO i polityką prywatności.",
    ],
  },
  {
    id: "c6",
    title: "§6 Opłaty, prowizje i rejestracja",
    items: [
      "Rejestracja konta Twórcy na Platformie jest bezpłatna.",
      "Platforma nie pobiera opłat abonamentowych ani opłat za utrzymanie konta.",
      "Operator Platformy pobiera wyłącznie prowizję od sprzedaży Produktów Cyfrowych Twórcy.",
      "Wysokość prowizji ustalana jest indywidualnie lub publikowana w aktualnym cenniku dostępnym na Platformie.",
      "Operator zastrzega sobie prawo do zmiany wysokości prowizji z zachowaniem co najmniej 14-dniowego okresu informacyjnego.",
      "Prowizja naliczana jest od ceny brutto sprzedaży Produktu.",
      "Rozliczenia z Twórcą dokonywane są w cyklach miesięcznych, na podstawie zestawień sprzedażowych.",
      "Twórca zobowiązany jest do wystawienia faktury lub innego dokumentu księgowego zgodnie z obowiązującymi przepisami.",
      "Operator ma prawo wstrzymać wypłatę środków w przypadku naruszenia Regulaminu.",
    ],
  },
  {
    id: "c7",
    title: "§7 Dodatkowe zasady współpracy",
    items: [
      "Twórca zobowiązuje się do aktualizowania swoich danych kontaktowych i rozliczeniowych.",
      "Twórca ponosi pełną odpowiedzialność za treści publikowane na Platformie.",
      "Zabrania się publikowania treści sprzecznych z prawem, dobrymi obyczajami lub regulaminem.",
      "Operator ma prawo do czasowego zawieszenia konta w przypadku podejrzenia naruszeń.",
      "Twórca zobowiązuje się do współpracy w zakresie obsługi reklamacji.",
      "Twórca nie może wykorzystywać Platformy ani jej bazy klientów do działań mających na celu omijanie prowizji, w szczególności poprzez przekierowywanie klientów poza system Platformy. Twórca zachowuje prawo do sprzedaży swoich Produktów w innych kanałach.",
      "Wszelkie spory będą rozstrzygane w pierwszej kolejności polubownie.",
    ],
  },
  {
    id: "c8",
    title: "§8 Postanowienia końcowe",
    content: [
      "Regulamin podlega prawu polskiemu.",
    ],
  },
];

export const newsletterRegulationsSections = [
  {
    id: "n1",
    title: "§1 Postanowienia ogólne",
    content: [
      "Niniejszy Regulamin określa zasady korzystania z usługi newslettera świadczonej przez [NAZWA FIRMY] z siedzibą w [ADRES], NIP: [], REGON: [], dalej zwanej „Administratorem”.",
      "Usługa newslettera polega na przesyłaniu drogą elektroniczną informacji handlowych, marketingowych, edukacyjnych oraz ofertowych dotyczących działalności Platformy.",
      "Korzystanie z newslettera jest dobrowolne i bezpłatne.",
    ],
  },
  {
    id: "n2",
    title: "§2 Warunki korzystania z newslettera",
    items: [
      "Subskrypcja newslettera wymaga podania adresu e-mail oraz wyrażenia zgody na otrzymywanie informacji handlowych drogą elektroniczną.",
      "Zapis do newslettera następuje poprzez formularz dostępny na stronie internetowej Platformy.",
      "Użytkownik oświadcza, że podany adres e-mail jest prawidłowy i należy do niego.",
      "Administrator stosuje mechanizm double opt-in (potwierdzenie zapisu), w celu weryfikacji subskrypcji.",
    ],
  },
  {
    id: "n3",
    title: "§3 Zakres treści newslettera",
    items: [
      "informacje o nowych produktach i twórcach",
      "promocjach i rabatach",
      "wydarzeniach, konkursach i akcjach specjalnych",
      "treści edukacyjne i inspiracyjne związane z tematyką Platformy",
      "informacje organizacyjne",
    ],
    content: [
      "Administrator zastrzega sobie prawo do zmiany zakresu treści newslettera.",
    ],
  },
  {
    id: "n4",
    title: "§4 Rezygnacja z newslettera",
    items: [
      "Użytkownik może w każdej chwili bez podania przyczyny zrezygnować z otrzymywania newslettera.",
      "Rezygnacja następuje poprzez kliknięcie linku „wypisz się” znajdującego się w każdej wiadomości lub poprzez kontakt z Administratorem.",
      "Rezygnacja z newslettera jest równoznaczna z usunięciem adresu e-mail z bazy mailingowej.",
    ],
  },
  {
    id: "n5",
    title: "§5 Ochrona danych osobowych (RODO)",
    items: [
      "Administratorem danych osobowych jest [NAZWA FIRMY].",
      "Dane osobowe przetwarzane są w celu realizacji usługi newslettera na podstawie zgody Użytkownika.",
      "Podanie danych jest dobrowolne, ale niezbędne do otrzymywania newslettera.",
      "Użytkownik ma prawo do dostępu do danych, ich poprawiania, usunięcia, ograniczenia przetwarzania oraz cofnięcia zgody w dowolnym momencie.",
    ],
    content: [
      "Szczegółowe informacje dotyczące przetwarzania danych znajdują się w Polityce Prywatności dostępnej na stronie Platformy.",
    ],
  },
  {
    id: "n6",
    title: "§6 Postanowienia końcowe",
    content: [
      "Administrator zastrzega sobie prawo do zmiany Regulaminu z ważnych przyczyn prawnych, organizacyjnych lub technologicznych.",
      "O zmianach Użytkownicy zostaną poinformowani drogą elektroniczną.",
      "W sprawach nieuregulowanych zastosowanie mają przepisy prawa polskiego.",
      "Regulamin obowiązuje od dnia [DATA].",
    ],
  },
];